import { Injectable } from '@angular/core';
import { RepositoryService } from '../../helpers/crud/repository.service';
import { WancomHttpService } from '../../services/wancom-http/wancom-http.service';
import { WaitingService } from '../layout/waiting/waiting.service';


@Injectable()
export class AccountDetailService extends RepositoryService<any> {
	constructor(http: WancomHttpService, waiting$: WaitingService) {
		super(http, waiting$, 'accountDetail');
	}

	public getInfos() {
        return this.http.get<WVUserInfo>(`${this.url}/getInfos`);
	}

}



export class WVUserInfo {
	id: string;
	firstName: string;
    lastName: string;
    login: string;
    email: string;
    phone: string;
    users?: WVUserInfosUsrPreview[];
    orgas?: WVUserInfosOrgPreview[];
    orgasSorted?: WVUserInfosOrgShortedPreview[];
    rights?: WVUserInfosRight[];
}

export class WVUserInfosUsrPreview{
    id: string;
    firstName: string;
    lastName:string;
}

export class WVUserInfosOrgPreview{
    id: number;
    parentId: number;
    orgName: string;
    package: string;
    endDate? : Date;
    primaryColorWanview?: string;
    secondaryColorWanview?: string;
    tertiaryColorWanview?: string;
}

export class WVUserInfosOrgShortedPreview{
    parent: WVUserInfosOrgPreview;
    children: WVUserInfosOrgPreview[];
}

export class WVUserInfosRight{
	rightName:string;
	faceId?: number;
}
